var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('p',{staticClass:"hint mt-4"},[_vm._v(" При появлении вопросов напишите нам на почту «"),_c('span',{staticClass:"subtitle"},[_vm._v("ams.support@mozlab.ru")]),_vm._v("» ")])])}
var staticRenderFns = []

export { render, staticRenderFns }